import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { DrawerTypes } from '@dtx-company/inter-app/src/redux/slices/drawer'
import { FAQButton } from '../../components/Reports/FAQButton'
import { FC, useEffect } from 'react'
import { ReportsDataFreshnessBanner } from '../../components/Reports/ReportsDataFreshnessBanner'
import { ReturnToReports } from '../../components/Reports/Controls/ReturnToReports'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { theme } from '@dtx-company/shared-components/src'
import { useCanViewReport } from '../../hooks/useCanViewReport'
import { useReportDashboardState } from './reportDashboard.hooks'
import { useRouter } from 'next/router'
import events from '@dtx-company/inter-app/src/event-tracking/events/flowlytics'

export const ReportDashboardContainer: FC = () => {
  const router = useRouter()
  const { isLoading, error, embedUrl, embedIFrameRef, updateDashboardFiltersFromQuery } =
    useReportDashboardState()
  const { canViewReport } = useCanViewReport()
  const reportSlug = router.query.dashboard_slug

  useEffect(() => {
    if (error || !canViewReport(reportSlug)) router.replace(Routes.NOT_FOUND)
  }, [canViewReport, error, reportSlug, router])

  useEffect(() => {
    updateDashboardFiltersFromQuery()
  }, [updateDashboardFiltersFromQuery])

  return isLoading ? (
    <></>
  ) : (
    <Box flexDirection="column" height="100%">
      <ReportsDataFreshnessBanner />
      <Box
        borderBottom={'2px solid ' + theme.colors.secondary.backgroundDark}
        justifyContent="space-between"
      >
        <ReturnToReports />
        <Box mr={{ _: '48px', md: '24px' }}>
          <FAQButton
            drawerType={DrawerTypes.FLOWLYTICS_GETTING_STARTED}
            shortText
            callback={() => {
              events.Flowlytics_GettingStarted_Opened_FAQ_Drawer({ open: true })
            }}
          />
        </Box>
      </Box>
      {embedUrl && (
        <iframe
          ref={embedIFrameRef}
          src={embedUrl}
          width="100%"
          style={{ border: 'none' }}
          height="100%"
        />
      )}
    </Box>
  )
}
